import type { DOMNode, HTMLReactParserOptions } from 'html-react-parser';
import { domToReact, Element } from 'html-react-parser';
import type { ElementType } from 'react';

const isSelfClosedTag = (tagName: string) => {
    const selfClosedTagList = [
        'area',
        'base',
        'br',
        'col',
        'embed',
        'hr',
        'img',
        'input',
        'link',
        'meta',
        'param',
        'source',
        'track',
        'wbr',
    ];

    return selfClosedTagList.findIndex(tag => tag === tagName) !== -1;
};

export const reactHtmlParserOptions: HTMLReactParserOptions = {
    replace: domNode => {
        if (!(domNode instanceof Element)) {
            return null;
        }

        // Filter script tag
        if (domNode.type === 'script') {
            return null;
        }

        // Filter every even handlers on elements
        if (domNode.attribs) {
            const cleanAttributes = Object.fromEntries(
                Object.entries(domNode.attribs).filter(([key]) => !key.startsWith('on'))
            );

            const Tag = domNode.name as ElementType;
            const children = domNode.children as DOMNode[];

            if (isSelfClosedTag(domNode.name)) {
                return <Tag {...cleanAttributes} />;
            }

            return <Tag {...cleanAttributes}>{domToReact(children, reactHtmlParserOptions)}</Tag>;
        }

        return domNode;
    },
};
